import { useSelector } from 'react-redux'

import { selectAppName } from 'root-redux/selects/common'
import { selectUserCountry } from 'root-redux/selects/user'

import { AppName, US_COUNTRY_CODE } from 'root-constants'

export const useIsDancebitUsComplianceFlow = (): boolean => {
  const appName = useSelector(selectAppName)
  const country = useSelector(selectUserCountry)

  return (
    appName === AppName.DANCEBIT && country.toUpperCase() === US_COUNTRY_CODE
  )
}
